import { entityType } from "enums/entity.type.enum"

export function checkEntity(data, entities): boolean{
    if (entities.find(uniao => uniao?.tipo == entityType.uniao && uniao?.id == data?.uniao_id) || entities.find(campo => campo?.tipo == entityType.campo && campo?.id == data?.campo_id) || entities.find(entidade => entidade?.tipo == entityType.entidade && entidade?.id == data?.entidade_id))
        return true
    return false
}
